import NotificationCard from "./NotificationCard";

export default function ProjectNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="project"
            destination={"/projects/v?key=" + props.notification.key}
        />
    );
}
